const Landing = () => import('../views/Landing')
const ForgotPassword = () => import('../views/ForgotPassword')
const ResetPassword = () => import('../views/ResetPassword')

export const authRoutes = [
	{
		path: '/login',
		name: 'login',
		component: Landing
	},
	{
		path: '/forgot-password',
		name: 'forgotPassword',
		component: ForgotPassword
	},
	{
		path: '/reset-password',
		name: 'resetPassword',
		component: ResetPassword
	}
]
